// @ts-nocheck
import { request } from 'sonata-react-components';

export async function downloadPDFReport(userId: string, campaignIds: string[], requestData: Record<string, any>) {
  const { includePublicUrl, ...templateData } = requestData;
  return request.makeRequest(`${taptap.config.backendUrlBase}report/${userId}/downloadPdf`, {
    data: {
      campaignIds,
      ...templateData
    },
    method: 'POST',
    params: {
      includePublicUrl
    }
  });
}

export async function getLastPdfReport(
  userId: string,
  campaignIds: string[],
  template: string,
  token?: Record<string, any>
) {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/${userId}/downloadPdf/last`,
    {
      data: {
        campaignIds,
        template
      },
      method: 'POST'
    },
    token
  );
}

export async function getPdfReportUrl(pdfId: string, userId: string, token: Record<string, any>) {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/${userId}/downloadPdf/${pdfId}/url`,
    {
      method: 'GET'
    },
    token
  );
}
